export default __webpack_public_path__ + "5b65701b45bb4f8df62376a4b2250854.png";